import { render, staticRenderFns } from "./reportDetails.vue?vue&type=template&id=1143276a&scoped=true"
import script from "./reportDetails.vue?vue&type=script&lang=js"
export * from "./reportDetails.vue?vue&type=script&lang=js"
import style0 from "./reportDetails.vue?vue&type=style&index=0&id=1143276a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1143276a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1143276a')) {
      api.createRecord('1143276a', component.options)
    } else {
      api.reload('1143276a', component.options)
    }
    module.hot.accept("./reportDetails.vue?vue&type=template&id=1143276a&scoped=true", function () {
      api.rerender('1143276a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinancialManagementOld/reportDetails.vue"
export default component.exports